// authThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { loginUser } from '../auth/authService';
import { handleApiError } from '../../utils/handleApiError';

export const loginUserThunk = createAsyncThunk(
    'auth/loginUser',
    async ({ email, password }, { rejectWithValue }) => {
        try {
            const data = await loginUser(email, password);
            return data;
        } catch (error) {
            handleApiError(error)
        }
    }
);
